import { Tooltip } from 'framework/ui/mui-builder';
import { CustomBadge, FieldBadgeProps } from 'framework/ui/ui-builder';
import { useFieldHelper } from 'framework/ui/field';

type PositionSlotMultipleEmployeesBadgeProps = FieldBadgeProps & {
  source?: string;
};

const PositionSlotMultipleEmployeesBadge = ({
  source = 'employeeAliases',
  ...props
}: PositionSlotMultipleEmployeesBadgeProps) => {
  const { getValue } = useFieldHelper<string[] | undefined>({ source });
  const employeeAliases = getValue() || [];

  return (
    <Tooltip title={`Assigned to employees: ${employeeAliases.join(', ')}`}>
      <span style={{ display: 'inline-flex', alignItems: 'center', verticalAlign: 'middle' }}>
        <CustomBadge text="Multiple employees assigned" color="warning" {...props} />
      </span>
    </Tooltip>
  );
};

export default PositionSlotMultipleEmployeesBadge;
